module.exports = __webpack_public_path__ + "assets/playlist-editor.9a432819.svg";